import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./DiscountCard.css";
import { usePartner } from "../../context/PartnerContext";
import {
  DEFAULT_SESSION_FEE,
  DEFAULT_STRIKE_PRICE,
  getSessionFee,
  getStrikePrice,
} from "../../utils/pricing";

const DiscountCard = () => {
  const [fee, setFee] = useState(DEFAULT_SESSION_FEE);
  const [discount, setDiscount] = useState("9% Off");
  const [strikePrice, setStrikePrice] = useState(DEFAULT_STRIKE_PRICE);

  const { config } = usePartner() || {};
  const { partnerSlug } = useParams();

  useEffect(() => {
    const nextFee = getSessionFee({ partnerSlug, config });
    const baseStrike = getStrikePrice(nextFee);
    const percent = Math.round(((baseStrike - nextFee) / baseStrike) * 100);

    setFee(nextFee);
    setStrikePrice(baseStrike);
    setDiscount(`${percent}% Off`);
  }, [config, partnerSlug]);

  return (
    <div className="discount-card">
      <div className="card-left">
        <p className="card-title">Single Session Booking</p>
        <p className="card-subtitle">40 minute session</p>
      </div>
      <div className="card-right">
        <p className="card-price">{"\u20B9"}{fee}</p>
        <div className="card-discount-row">
          <p className="card-strike">{"\u20B9"}{strikePrice}</p>
          <div className="card-tag">
            <p className="card-tag-text">{discount}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountCard;
